import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[LayoutHostRuntime]',
  exportAs: 'LayoutHostRuntimeDirective'
})
export class LayoutHostRuntimeDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
